export const getOrderFromDescription = (description: string | null) => {
  if (!description) return 0
  try {
    const parsedDescription = JSON.parse(description)
    return parsedDescription.order ?? 0
  } catch (error) {
    return 0
  }
}
